"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createFormatState() {
    return {
        fontName: '',
        fontSize: '',
        isBold: false,
        isItalic: false,
        isUnderline: false,
        backgroundColor: '',
        textColor: '',
        isBullet: false,
        isNumbering: false,
        isStrikeThrough: false,
        isSubscript: false,
        isSuperscript: false,
        isBlockQuote: false,
        canUnlink: false,
        canAddImageAltText: false,
        canUndo: false,
        canRedo: false,
    };
}
exports.default = createFormatState;
//# sourceMappingURL=createFormatState.js.map